import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../components/PaginaToolbar';
import { criarAcessosNfseAntigaDs } from "../DataSources";
import uiInfo from "../ui-info";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";


export default class ConfiguracaoCndBox extends Component {
    constructor() {
        super();
        this.state = {
            showUserPopup: false,
            dadosAcesso: null,
        };
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
        this.verSenhaCpbs = this.verSenhaCpbs.bind(this);
        this.showDadosAcesso = this.showDadosAcesso.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
    }

    render() {

        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Acessos NFS-e Antiga">
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarAcessosNfseAntigaDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={false}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        onEditingStart={this.onAtualizandoRow}>
                        <FilterRow visible={true} />
                        <Column
                            type="buttons"
                            buttons={[
                                {
                                    hint: "Usuários do CPBS",
                                    icon: "group",
                                    visible: !this.usadoComoPesquisa,
                                    onClick: (e) => this.showDadosAcesso(e.row.data),
                                },
                            ]}
                        />
                        <Editing allowDeleting={false} allowUpdating={false} allowAdding={false} mode="row" />
                        <Column dataField={'inscricao'} caption={"Inscrição"} width={'150px'} />
                        <Column dataField={'cpfCnpj'} caption={"CPF/CNPJ"} width={'150px'} />
                        <Column dataField={'nome'} caption={"Nome"} />
                        <Column dataField={'prefeitura'} caption={"Prefeitura"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
                <Popup
                    visible={this.state.showUserPopup}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showCloseButton={false}
                    showTitle={true}
                    title={"Dados de Acesso"}
                    onHiding={() => this.setState({ showUserPopup: false })}
                    width="400px"
                    height="250px"
                >
                    <ScrollView>
                        <div style={{ marginBottom: 15 }}>
                            <Form id="frmDadosUsuarioCpbs" formData={this.state.dadosAcesso} colCount={1}>
                                <SimpleItem
                                    dataField="textoAcesso"
                                    editorType="dxTextArea"
                                    colSpan={1}
                                    editorOptions={{ readOnly: true, height: 80 }}
                                >
                                    <Label visible={false} />
                                </SimpleItem>
                            </Form>
                        </div>
                    </ScrollView>
                    <ToolbarItem
                        toolbar={"bottom"}
                        widget="dxButton"
                        location="center"
                        options={{
                            text: "Fechar",
                            width: 150,
                            onClick: () => this.setState({ showUserPopup: false }),
                        }}
                    ></ToolbarItem>
                </Popup>
            </div>
        );

    }

    verSenhaCpbs() {
        this.props.history.push("cpbs/novo");
    }

    showDadosAcesso(rowData) {
        const usuario = rowData.cpfCnpj || "";
        const senha  = rowData.senha || "";
        this.setState({
            showUserPopup: true,
            dadosAcesso: {
                ...rowData,
                textoAcesso: `Usuário: ${usuario}\nSenha: ${senha}`
            }
        })
    }
}
